// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Button,
  Container,
  CardMedia,
  Grid,
  Link,
  Typography,
} from "@mui/material";

// third party
// import { motion } from "framer-motion";

// project import
import AnimateButton from "../../components/@extended/AnimateButton";

// types
import { ThemeMode } from "../../types/config";

// assets
// import { DownloadOutlined } from "@ant-design/icons";

import imgbg from "../../assets/images/landing/img-bg-screen.png";
import { navigateToUrl } from "single-spa";

// ==============================|| LANDING - CALL TO ACTION PAGE ||============================== //

const CallToActionPage = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        bgcolor: "#141414",
        // bgcolor:
        //   theme.palette.mode === ThemeMode.DARK
        //     ? theme.palette.grey[100]
        //     : theme.palette.secondary[800],
        "&:after": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "80%",
          bottom: 0,
          left: 0,
          background: `linear-gradient(180deg, transparent, #141414)`,
          // background: `linear-gradient(180deg, transparent, ${
          //   theme.palette.mode === ThemeMode.DARK
          //     ? theme.palette.grey[100]
          //     : theme.palette.secondary[800]
          // })`,
        },
      }}
    >
      <CardMedia
        component="img"
        image={imgbg}
        sx={{ width: "auto", position: "absolute", top: 0, right: 0 }}
      />
      <Container>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{
            position: "relative",
            zIndex: 1,
            pt: { md: 18.75, xs: 7.5 },
            pb: { md: 10, xs: 3.75 },
          }}
        >
          <Grid item xs={12} md={7} sx={{ position: "relative", zIndex: 1 }}>
            <Grid
              container
              spacing={2}
              sx={{
                [theme.breakpoints.down("md")]: { pr: 0, textAlign: "center" },
              }}
            >
              <Grid item xs={12}>
                <div>
                  <Typography
                    variant="h2"
                    sx={{
                      color: theme.palette.common.white,
                      fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                      fontWeight: 700,
                      lineHeight: { xs: 1.4, sm: 1.4, md: 1.4 },
                    }}
                  >
                    <Box component="span" sx={{ mx: 0 }}>
                      Vá além das soluções padrão. Com o Bemsign, obtenha
                      autenticação, validação e assinatura
                    </Box>
                    <Box
                      component="span"
                      sx={{ mx: 0, color: theme.palette.primary.main }}
                    >
                      &nbsp;adaptadas às suas necessidades&nbsp;
                    </Box>
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={12} sx={{ my: 3.25 }}>
                <div>
                  <AnimateButton>
                    <Button
                      component={Link}
                      target="_blank"
                      size="large"
                      color="primary"
                      variant="contained"
                      onClick={() => navigateToUrl("/login")}
                      // startIcon={<DownloadOutlined />}
                    >
                      Entre em Contato
                    </Button>
                  </AnimateButton>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default CallToActionPage;
